<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'AccountExports'}" class="subtitle-1 routerLink font-weight-medium">Exportar</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>Transferencias
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 pb-0 background">
          <v-row class="px-4">
            <v-col cols="12" sm="10" md="9">
              <span class="body-2 text--secondary font-weight-medium">Filtrar registros</span>
              <v-query-builder :flat="true" :query-map="rules" filter-text="Previsualizar" model="transactions" />
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">Previsualización</span>
            </v-col>
          </v-row>
          <v-divider />
          <transaction-list :show-pagination="false" />
          <v-divider />
          <v-row class="px-4">
            <v-col>
              <span class="body-2 text--secondary font-weight-medium">{{count}} registros</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="createExport" :loading="loader" color="primary">Exportar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import { transfersFilters } from '../../../collections/queryBuilderFilters'
import TransactionList from '@/components/bank/TransactionList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VQueryBuilder,
    TransactionList
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    isPreview: false,
    loader: false,
    rules: transfersFilters
  }),
  computed: mapState({
    count: state => state.banks.ach_transfersCount,
    list: state => state.banks.ach_transfersList
  }),
  methods: {
    getList () {
      this.$store.dispatch('banks/LIST', {
        resource: 'ach_transfers',
        query: Object.assign({}, this.$route.query, { page_size: 10 })
      })
    },
    str2bytes (str) {
      var bytes = new Uint8Array(str.length)
      for (var i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i)
      }
      return bytes
    },
    createExport () {
      this.loader = true

      this.$store.dispatch('accounts/LIST', {
        resource: 'exports/ach_transfers',
        query: this.$route.query,
        loader: true,
        responseType: 'arraybuffer'
      })
      .then(async (response) => {
        let blob = await new Blob([response.data], {type: "application/zip"})
        saveAs(blob, 'transfers.zip')
        this.$dialog.message.info('La exportación se realizó con éxito')
      })
      .catch(() => {
        this.$dialog.message.error('Ha ocurrido un error en la exportación')
      })
      .finally(() => {
        this.loader = false
      })
    }
  }
}
</script>